<template >
  <v-container class="mt-5" :style="isAdmin ? {'max-width': '1400px'} : {'max-width': '1000px'}">
    <v-card flat outlined class="pa-4">
      <v-row class="py-2 font-weight-bold mb-2">
        <v-col align-self="center" style="margin-left: 16px" dark>
          <h3 style="font-size: 1.375rem">My Projects</h3>
        </v-col>
        <v-col style="text-align: right" class="mr-4">
          <v-btn id="newProjectBtn" color="primary" router :to="'/Newproject'">
            New Project
          </v-btn>
        </v-col>
      </v-row>

      <data-table
        :projects="Projects"
        :Loading="loading"
        :headers="projectHeaders"
        source="user-projects"
      />
      <br><br>
      <v-row>
        <v-col class="col-5">
          <b>&nbsp;Published</b>
          <br><br>
          <v-chip small color="green"></v-chip>
          Published
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <v-chip small color="red"></v-chip>
          Unpublished
        </v-col>
        <v-col>
          <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Status</b>
          <br><br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <v-chip small color="blue"></v-chip>
        Analysis Input Required
          &nbsp;&nbsp;&nbsp;
        <v-chip small color="yellow"></v-chip>
        Analysis in Progress
          &nbsp;&nbsp;&nbsp;
        <v-chip small color="green"></v-chip>
        Analysis Completed
          &nbsp;&nbsp;&nbsp;
        <v-chip small color="red"></v-chip>
        Analysis Failed
          
        </v-col>
      </v-row>
    <br>
    </v-card>
  </v-container>
</template>
<script>
import DataList from "@/services/dataliststore.js";
import DataTable from "@/components/DataTable";
import moment from "moment";

export default {
  name: "Dashboard",
  data() {
    return {
      Projects: [],
      currentuser: "",
      loading: "",
      projectHeaders: [
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "title",
        },
        { 
          text: "Last Updated", 
          value: "_updated", 
          width: "15%", 
          sort: (a, b) => {
            return moment.utc(a).diff(moment.utc(b))
          }
        },
        {
          text: "Status",
          value: "status",
          tooltip: this.statusTooltip,
          width: "10%",
          align: "center",
        },
        {
          text: "Published",
          value: "isPublished",
          width: "12%",
          align: "center",
        },
        {
          text: "Actions",
          value: "action",
          width: "22%",
          align: "center",
          sortable: false,
        },
        {
          text: "Report",
          value: "Report",
          width: "22%",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  components: {
    DataTable
  },
  methods: {
    getProjectList() {
      this.loading = true;
      DataList.methods.fetchData("user-projects").then((res) => {
        const sortedList = res.sort((a, b) => {
            return moment.utc(b._updated).diff(moment.utc(a._updated))
        });
        this.Projects = sortedList;
        this.loading = false;
      });
    },
  },
  mounted(){
    if (this.isAdmin) {
      this.projectHeaders = [
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "title",
        },
        { 
          text: "Last Updated", 
          value: "_updated", 
          width: "12%", 
          sort: (a, b) => {
            return moment.utc(a).diff(moment.utc(b))
          }
        },
        {
          text: "Status",
          value: "status",
          tooltip: this.statusTooltip,
          width: "7.5%",
          align: "center",
        },
        { text: "Status Desc", value: "statusDesc", width: "8%" },
        { text: "Analysis Status", value: "analysisStatus", width: "8%" },
        {
          text: "Published",
          value: "isPublished",
          width: "9%",
          align: "center",
        },
        {
          text: "Actions",
          value: "action",
          width: "20%",
          align: "center",
          sortable: false,
        },
        {
          text: "Report",
          value: "Report",
          width: "5%",
          align: "center",
          sortable: false,
        },
      ];
    }
  },
  created() {
    this.getProjectList();
  },
  computed: {
    active() {
      let active = [
        { name: "Active", shortName: false },
        { name: "Deleted", shortName: true },
      ];
      return active;
    },
    isAdmin() {
      const adminStatus = window.localStorage.getItem("admin");
      if (adminStatus) {
        return (adminStatus === "true");
      }
      return false;
    },
  }
}
</script>